module.exports = __webpack_public_path__ + "img/40.29ff3f6a.jpg";